"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Range_1 = __importDefault(require("../../../Util/Range"));
const State_1 = require("../types/State");
const getBehaviourOfWeek_1 = __importDefault(require("./graphql/getBehaviourOfWeek"));
const getBehaviourOfDay_1 = __importDefault(require("./graphql/getBehaviourOfDay"));
const prepareQueryForBehaviourWeeks_1 = require("./graphql/prepareQueryForBehaviourWeeks");
const flatArray_1 = require("../../../Util/flatArray");
const getSubscriptionWeekFromDate_1 = require("../../../Util/getSubscriptionWeekFromDate");
const byDateSort_1 = __importDefault(require("../../../BusinessLogicLayer/byDateSort"));
class Behaviour {
    constructor(client, dateTimeProvider, dateTimeModifier, customerApi, periodPicker, fetch, logger) {
        this.getDateRange = async (userId, dateRange) => {
            const { periods } = await this.customerApi.fetchCustomer(userId);
            const periodsInRange = this.periodPicker.pickPeriods(periods, dateRange);
            const promises = [];
            if (this.dateTimeProvider.weekFromDate(dateRange.to) ===
                this.dateTimeProvider.weekFromDate(dateRange.from) &&
                this.dateTimeModifier.yearDiff(dateRange.to, dateRange.from) === 0) {
                const period = periodsInRange.find(({ startDate, endDate }) => this.dateTimeModifier.dateInDateRange(startDate, endDate, dateRange.to));
                promises.push(this.client.fetch("getBehaviourQuery", getBehaviourOfWeek_1.default, {
                    subscriptionId: parseInt(period === null || period === void 0 ? void 0 : period.periodId),
                    day: null,
                    week: (0, getSubscriptionWeekFromDate_1.getWeekNumberFromDateRangeByDate)(dateRange.to, period),
                }));
            }
            else {
                const args = (0, getSubscriptionWeekFromDate_1.prepareArgsForDifferentWeeksQuery)(periodsInRange, dateRange);
                if (args.length === 0) {
                    return { days: [] };
                }
                promises.push(this.client.fetch("getBehaviourQuery", (0, prepareQueryForBehaviourWeeks_1.prepareBehaviorWeekQuery)(args), null));
            }
            const res = await Promise.all(promises);
            const days = res
                .map((response) => Object.values(response).reduce(flatArray_1.flatArray, []))
                .reduce(flatArray_1.flatArray, [])
                .filter((day) => {
                const [date] = day.date.split("T");
                return this.dateTimeModifier.dateIsSameOrAfter(date, dateRange.from);
            })
                .filter((day) => {
                const [date] = day.date.split("T");
                return this.dateTimeModifier.dateIsSameOrAfter(dateRange.to, date);
            })
                .map(this.mapWeekDay)
                .sort(byDateSort_1.default);
            return {
                days,
            };
        };
        this.getDate = async (customerId, date) => {
            const period = await this.periodPicker.pickPeriod((await this.customerApi.fetchCustomer(customerId)).periods, new Range_1.default(date, date));
            const dayNo = this.dateTimeModifier.daysDiff(period.startDate, date);
            const result = (await this.client.fetch("getBehaviourOfDay", getBehaviourOfDay_1.default, {
                subscriptionId: parseInt(period.periodId),
                day: dayNo + 1,
                week: null,
            }));
            if (result.progressCollection.length === 0) {
                return null;
            }
            return this.mapDay(result.progressCollection[0]);
        };
        this.mapWeekDay = (progressItem) => {
            return {
                date: this.dateTimeProvider.fromDateTimeToDate(progressItem.date),
                isDone: (0, State_1.asBool)(progressItem.didLesson),
                lessonOrdinalNumber: progressItem.lessonOrdinalNumber,
                lessonTitle: progressItem.lessonTitle,
            };
        };
        this.mapDay = async (progressItem) => {
            return {
                ...this.mapWeekDay(progressItem),
                memberAnswer: (progressItem.memberAnswer
                    ? {
                        ...progressItem.memberAnswer,
                        imageUrl: await this.getImage(progressItem.memberAnswer.imageUrl),
                    }
                    : {}),
                lessonDescription: progressItem.lessonDescription,
            };
        };
        this.getImage = async (imageUrl) => {
            if (!imageUrl) {
                return undefined;
            }
            try {
                return (await this.fetch.fetch(imageUrl, {}, true, null));
            }
            catch (e) {
                this.logger.error(e);
                return undefined;
            }
        };
        this.client = client;
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.customerApi = customerApi;
        this.periodPicker = periodPicker;
        this.fetch = fetch;
        this.logger = logger;
    }
}
exports.default = Behaviour;
//# sourceMappingURL=Behaviour.js.map